import { RichTextWebPageMetadataByUrlQuery } from '#app/__generated__/relay/RichTextWebPageMetadataByUrlQuery.graphql.js';
import { CustomEditorContent, renderReadOnlyContent } from '@contra/editor';
import { fetchQuery, graphql, useRelayEnvironment } from '@contra/relay';
import { useCallback } from 'react';
// eslint-disable-next-line import/no-unassigned-import
import '@contra/editor/css/style.css';

type RichTextProps = {
  readonly content: CustomEditorContent;
  readonly maxLengthBeforeTruncation?: number;
  onShowMore?: () => void;
};

export const RichText = ({
  content,
  maxLengthBeforeTruncation,
  onShowMore,
}: RichTextProps) => {
  const relay = useRelayEnvironment();
  const fetchWebPageMetadata = useCallback(
    async (url: string) => {
      try {
        const data = await fetchQuery<RichTextWebPageMetadataByUrlQuery>(
          relay,
          graphql`
            query RichTextWebPageMetadataByUrlQuery($url: String!) {
              webPageMetadataByUrl(url: $url) {
                id
                description
                embedUrl
                openGraphImage {
                  uid
                }
                title
              }
            }
          `,
          { url },
        ).toPromise();

        return data?.webPageMetadataByUrl ?? null;
      } catch {
        return null;
      }
    },
    [relay],
  );

  return renderReadOnlyContent({
    document: content,
    fetchWebPageMetadata,
    maxLength: maxLengthBeforeTruncation,
    onShowMore,
  });
};
